import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    openPositions: [],
    openPositionsFilter: "Alles",
    shouldUpdateMatchedProfiles: {},
    shouldUpdateFavoriteProfiles: {},
    shouldUpdateDismissedProfiles: {},
    hasDetailsDialogUnsavedChanges: false
}

const slice = createSlice({
  name: 'positions',
  initialState,
  reducers: {
    setOpenPositions: (state, { payload }) => {
      return {...state, openPositions: payload}
    },
    setCardProcessing: (state, { payload: { id, flag } }) => ({
        ...state,
        openPositions: state.openPositions.map((card) =>
          card.id === id ? { ...card, is_processing: flag } : card
        ),
      }),
      setMatchedProfilesForVacancy: (state, { payload: { id, matchedProfile } }) => ({
        ...state,
        openPositions: state.openPositions.map((card) =>
          card.id === id ? {
            ...card,
            matchedProfilesForVacancy: [...matchedProfile]
          } : card
        ),
      }),
      setErrorForVacancy: (state, { payload: { id, hasError } }) => ({
        ...state,
        openPositions: state.openPositions.map((card) =>
          card.id === id ? { ...card, hasError } : card
        ),
      }),
      setUpdateMatchedProfiles: (state) => ({ ...state, shouldUpdateMatchedProfiles: {} }),
      setUpdateFavoriteProfiles: (state) => ({ ...state, shouldUpdateFavoriteProfiles: {} }),
      setUpdateDismissedProfiles: (state) => ({ ...state, shouldUpdateDismissedProfiles: {} }),
      setOpenPositionsSortingFilter: (state, { payload }) => ({ ...state, openPositionsFilter: payload }),
      setDetailsDialogUnsavedChanges: (state, { payload }) => ({ ...state, hasDetailsDialogUnsavedChanges: payload }),
  },
})

const { reducer, actions } = slice

export const { 
    setOpenPositions, 
    setCardProcessing,
    setMatchedProfilesForVacancy,
    setErrorForVacancy,
    resetOpenPositions,
    setUpdateMatchedProfiles,
    setUpdateFavoriteProfiles,
    setUpdateDismissedProfiles,
    setOpenPositionsSortingFilter,
    setDetailsDialogUnsavedChanges,
} = actions

export default reducer
